import { createSelector } from '@reduxjs/toolkit';
import { campaignsSelectors } from '../campaignsSelectors';

export const getCampaignHealthStatus = createSelector(
  [campaignsSelectors.selectById],
  (campaign) => {
    return campaign?.healthStatus;
  }
);
